import { render, staticRenderFns } from "./MembersWidget.vue?vue&type=template&id=3eb4e708&scoped=true"
import script from "./MembersWidget.vue?vue&type=script&lang=js"
export * from "./MembersWidget.vue?vue&type=script&lang=js"
import style0 from "./MembersWidget.vue?vue&type=style&index=0&id=3eb4e708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb4e708",
  null
  
)

export default component.exports